export enum ColorName {
  BrowserColorScheme = 'BrowserColorScheme',
  KeylineDefault = 'KeylineDefault',
  LinkDefault = 'LinkDefault',
  LinkHover = 'LinkHover',
  LinkDisabled = 'LinkDisabled',
  TextDefault = 'TextDefault',
  TextLight = 'TextLight',
  TextLighter = 'TextLighter',
  TextDisabled = 'TextDisabled',
  TextRed = 'TextRed',
  TextYellow = 'TextYellow',
  TextGreen = 'TextGreen',
  TextBlue = 'TextBlue',
  TextOlive = 'TextOlive',
  TextCyan = 'TextCyan',
  TextLime = 'TextLime',
  BackgroundDefault = 'BackgroundDefault',
  BackgroundDefaultHover = 'BackgroundDefaultHover',
  BackgroundLight = 'BackgroundLight',
  BackgroundLightHover = 'BackgroundLightHover',
  BackgroundLighter = 'BackgroundLighter',
  BackgroundLighterHover = 'BackgroundLighterHover',
  BackgroundDisabled = 'BackgroundDisabled',
  BackgroundRed = 'BackgroundRed',
  BackgroundRedHover = 'BackgroundRedHover',
  BackgroundYellow = 'BackgroundYellow',
  BackgroundYellowHover = 'BackgroundYellowHover',
  BackgroundGreen = 'BackgroundGreen',
  BackgroundGreenHover = 'BackgroundGreenHover',
  BackgroundBlue = 'BackgroundBlue',
  BackgroundBlueHover = 'BackgroundBlueHover',
  BackgroundOlive = 'BackgroundOlive',
  BackgroundOliverHover = 'BackgroundOliverHover',
  BackgroundCyan = 'BackgroundCyan',
  BackgroundCyanHover = 'BackgroundCyanHover',
  BackgroundLime = 'BackgroundLime',
  BackgroundLimeHover = 'BackgroundLimeHover',
  BackgroundGray = 'BackgroundGray',
  BackgroundGrayHover = 'BackgroundGrayHover',
  BorderDefault = 'BorderDefault',
  BorderHover = 'BorderHover',
  BorderDisabled = 'BorderDisabled',
  FocusRing = 'FocusRing',
  AccentPrimary = 'AccentPrimary',
  AccentPrimaryHover = 'AccentPrimaryHover',
  AccentReversed = 'AccentReversed',
  AccentReversedHover = 'AccentReversedHover',
  AccentRed = 'AccentRed',
  AccentRedHover = 'AccentRedHover',
  AccentYellow = 'AccentYellow',
  AccentYellowHover = 'AccentYellowHover',
  AccentGreen = 'AccentGreen',
  AccentGreenHover = 'AccentGreenHover',
  AccentBlue = 'AccentBlue',
  AccentBlueHover = 'AccentBlueHover',
  AccentCyan = 'AccentCyan',
  AccentCyanHover = 'AccentCyanHover',
  AccentLime = 'AccentLime',
  AccentLimeHover = 'AccentLimeHover',
  AccentLavender = 'AccentLavender',
  AccentLavenderHover = 'AccentLavenderHover',
  AccentOlive = 'AccentOlive',
  AccentOliveHover = 'AccentOliveHover',
  AccentGray = 'AccentGray',
  AccentGrayHover = 'AccentGrayHover',
  AccentWhite = 'AccentWhite',
  AlwaysWhite = 'AlwaysWhite',
  DialogBackground = 'DialogBackground',
  TooltipBackground = 'TooltipBackground',
  TooltipText = 'TooltipText',
  PopoverBackground = 'PopoverBackground',
  PopoverBackgroundHover = 'PopoverBackgroundHover',
  ShadowDefault = 'ShadowDefault',
  CheckboxUnchecked = 'CheckboxUnchecked',
  CheckboxChecked = 'CheckboxChecked',
  CheckboxDisabled = 'CheckboxDisabled',

  // Header
  NavBackground = 'NavBackground',
  NavText = 'NavText',
  NavTextHover = 'NavTextHover',
  NavTextSelected = 'NavTextSelected',
  NavButton = 'NavButton',
  NavButtonHover = 'NavButtonHover',

  // Lineage Graph
  LineageEdge = 'LineageEdge',
  LineageEdgeHighlighted = 'LineageEdgeHighlighted',
  LineageGroupNodeBackground = 'LineageGroupNodeBackground',
  LineageGroupNodeBackgroundHover = 'LineageGroupNodeBackgroundHover',
  LineageGroupNodeBorder = 'LineageGroupNodeBorder',
  LineageGroupNodeBorderHover = 'LineageGroupNodeBorderHover',
  LineageGroupBackground = 'LineageGroupBackground',
  LineageNodeBackground = 'LineageNodeBackground',
  LineageNodeBackgroundHover = 'LineageNodeBackgroundHover',
  LineageNodeBorder = 'LineageNodeBorder',
  LineageNodeBorderHover = 'LineageNodeBorderHover',
  LineageNodeBorderSelected = 'LineageNodeBorderSelected',

  // Dataviz
  DataVizBlue = 'DataVizBlue',
  DataVizBlueAlt = 'DataVizBlueAlt',
  DataVizBlurple = 'DataVizBlurple',
  DataVizBlurpleAlt = 'DataVizBlurpleAlt',
  DataVizBrown = 'DataVizBrown',
  DataVizBrownAlt = 'DataVizBrownAlt',
  DataVizCyan = 'DataVizCyan',
  DataVizCyanAlt = 'DataVizCyanAlt',
  DataVizGray = 'DataVizGray',
  DataVizGrayAlt = 'DataVizGrayAlt',
  DataVizGreen = 'DataVizGreen',
  DataVizGreenAlt = 'DataVizGreenAlt',
  DataVizLime = 'DataVizLime',
  DataVizLimeAlt = 'DataVizLimeAlt',
  DataVizOrange = 'DataVizOrange',
  DataVizOrangeAlt = 'DataVizOrangeAlt',
  DataVizPink = 'DataVizPink',
  DataVizPinkAlt = 'DataVizPinkAlt',
  DataVizRed = 'DataVizRed',
  DataVizRedAlt = 'DataVizRedAlt',
  DataVizTeal = 'DataVizTeal',
  DataVizTealAlt = 'DataVizTealAlt',
  DataVizViolet = 'DataVizViolet',
  DataVizVioletAlt = 'DataVizVioletAlt',
  DataVizYellow = 'DataVizYellow',
  DataVizYellowAlt = 'DataVizYellowAlt',

  //Gradients
  BlueGradient = 'BlueGradient',
}
